<template>
    <Loader v-if="$loading.value"></Loader>
    <div>
      <Slider></Slider>

      <v-container style="padding-top: 40px;padding-bottom: 40px;" v-if="ProdutosDestaque!=''">
        <v-row>
            <v-col cols="12" md="12">
                <div class="section-tittle section-tittle6 mb-50">
                   <div class="front-text">
                       <h2 style="color:#000000;">Conheça nossos produtos</h2>
                   </div>
                </div>
            </v-col>
            <v-col cols="12" md="12">
                <Swiper :navigation="false" :spaceBetween="20" :pagination="{ clickable: true }" :slides-per-view="5" :breakpoints="{ 768: { slidesPerView: 4 }, 0: { slidesPerView: 1 } }" >
                    <SwiperSlide v-for="prod4car in ProdutosDestaque" :key="prod4car.proId">
                            <div class="product">
                                <figure class="product-media" style="text-align: center;">
                                    <span v-if="prod4car.proEtiqueta!='' && prod4car.proEtiqueta!=null" class="product-label label-sale">{{prod4car.proEtiqueta}}</span>
                                    <router-link :to="AjustaUrl('/produtosdetalhe/' + prod4car.proId, prod4car.proNomeProduto)">
                                        <img v-if="prod4car.proCampoExtra10!='' && prod4car.proCampoExtra10!=null" :src="$imgURL + prod4car.proCampoExtra10" alt="" class="product-image" style="height: 200px">
                                    </router-link>
                                </figure><!-- End .product-media -->

                                <div class="product-body" style="text-align: center;">
                                    <div class="product-cat">
                                    </div><!-- End .product-cat -->
                                    <h3 class="product-title" style="font-size: 18px !important;height: 50px;">
                                        <router-link :to="AjustaUrl('/produtosdetalhe/' + prod4car.proId, prod4car.proNomeProduto)">
                                            {{ prod4car.proNomeProduto}}
                                        </router-Link>
                                    </h3><!-- End .product-title -->
                                    <div class="product-price" v-if=" prod4car.proVisivel" style="justify-content: center;">
                                    </div><!-- End .product-price -->
                                    <div class="product-price" v-else>
                                        <span class="new-price">Indisponível</span>
                                    </div><!-- End .product-price -->
                                </div><!-- End .product-body -->
                            </div><!-- End .product -->
                    </SwiperSlide>
                </Swiper>
            </v-col>
        </v-row>
      </v-container>

      <v-container v-if="cores!=null" fluid :style="{backgroundColor:cores[0].itiCor1, paddingTop: '60px', paddingBottom: '60px'}">
        <v-container>
            <v-row justify="center" align="center">
                <v-col cols="12" md="3" v-for="(card, index) in itensHome" :key="index" style="text-align: center;">
                    <v-img height="200" :src="$imgURL + card.insInstitucionalImagens[0].itgUrlImagem" cover class="mx-auto" style="border-radius: 50%;width: 80px;height: auto;"></v-img>
                    <p style="color:#003399;font-size: 20px;font-weight: 600;padding-top: 10px;">{{ card.itiNome }}</p>
                    <p style="color:#000000;font-size: 15px">{{ card.itiReferencia }}</p>
                </v-col>
            </v-row>
        </v-container>
      </v-container>

      <v-container style="padding-top: 40px;padding-bottom: 60px;">
        <v-row>
            <v-col cols="12" md="12">
                <div class="section-tittle section-tittle6 mb-50">
                   <div class="front-text">
                     <h2 style="color:#000000;">Confira os últimos eventos!</h2>
                   </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" v-for="menu in blogLast.slice(0,4)" :key="menu.itiId">
                <v-card class="mx-auto" max-width="400">
                    <router-link :to="'/EventosDetalhe/' + menu.itiId + '/' + menu.itiNome.replaceAll(' ','-').replaceAll('/','').replaceAll(',','')" style="color:#443e40 !important">
                        <v-img class="align-end text-white" height="200" :src="$imgURL + menu.insInstitucionalImagens[0].itgUrlImagem" cover>
                            
                        </v-img>
                    </router-link>
                    <v-card-subtitle class="pt-4">
                        {{ formattedDate(menu.itiData1) }}
                    </v-card-subtitle>

                    <v-card-text>
                        <router-link :to="'/EventosDetalhe/' + menu.itiId + '/' + menu.itiNome.replaceAll(' ','-').replaceAll('/','').replaceAll(',','')" style="color:#443e40 !important">
                             <h5>{{ menu.itiNome }}</h5>
                        
                            <div>Local: {{ menu.itiCampoExtra1 }}</div>

                            <div style="height: 30px;">Duração: {{ menu.itiCampoExtra2 }}</div>
                        </router-link>
                    </v-card-text>

                    <v-card-actions>
                        <router-link :to="'/EventosDetalhe/' + menu.itiId + '/' + menu.itiNome.replaceAll(' ','-').replaceAll('/','').replaceAll(',','')" style="color:#443e40 !important">
                            Saiba mais
                        </router-link>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
      </v-container>

     

    
      <v-container-fluid>
            <v-row no-gutters justify="center">
            <v-col cols="12" md="6" v-for="(imagemDupla, index) in ImagensDuplas" :key="index">
                <router-link :to="imagemDupla.itiReferencia">
                    <div class="image-container">
                        <img v-if="imagemDupla.insInstitucionalImagens!=''" :src="$imgURL + imagemDupla.insInstitucionalImagens[0].itgUrlImagem" class="image" />
                    
                        <img v-else src="/imagens/semImg.jpg" class="image" />
                    <div class="overlay">
                        <div class="text">
                            
                                <h2 style="color:#ffffff;font-size:60px;font-weight: 600;">{{imagemDupla.itiNome}}</h2>
                            
                        <p style="width: 250px">{{ imagemDupla.itiCampoExtra1}}</p>
                        </div>
                    </div>
                    </div>
            </router-link>
            </v-col>
            </v-row>
    </v-container-fluid>
  

    <v-container style="padding-top: 60px;padding-bottom: 60px;" v-if="Atuacao!=''">
        <v-row>
            <v-col cols="12" md="12">
                <div class="section-tittle section-tittle6 mb-50">
                   <div class="front-text">
                        <h2 style="color:#000000;">{{ Atuacao[0].itiNome }}</h2>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <v-img height="100%" :src="$imgURL + Atuacao[0].insInstitucionalImagens[0].itgUrlImagem" cover class="mx-auto"></v-img>
            </v-col>
            <v-col cols="12" md="6">
                <h3>{{ Atuacao[0].itiReferencia }}</h3>
                <p v-html="Atuacao[0].itiResumo1"></p>
                <p v-html="Atuacao[0].itiResumo2"></p>
            </v-col>
        </v-row>
    </v-container>

    <v-container fluid :style="{backgroundColor:cores[0].itiCor2, paddingTop: '60px', paddingBottom: '60px'}" v-if="blog!='' && cores!=null">
        <v-container>
            <v-row>
                <v-col cols="12" md="12">
                    <div class="section-tittle section-tittle6 mb-50">
                              <div class="front-text">
                                  <h2 style="color:#000000;">Atualizações do setor Food</h2>
                              </div>
                    </div>
                </v-col>
            </v-row>
            <v-row justify="center">
            <v-col cols="12" sm="6" md="3" lg="3" v-for="menu in blog.slice(0,4)" :key="menu.itiId">
                <v-card class="mx-auto" max-width="400">
                    <router-link :to="'/BlogDetalhe/' + menu.itiId + '/' + menu.itiNome.replaceAll(' ','-').replaceAll('/','').replaceAll(',','')" style="color:#443e40 !important">
                       <v-img class="align-end text-white" height="200" :src="$imgURL + menu.insInstitucionalImagens[0].itgUrlImagem" cover>
                    </v-img>
                    </router-link>

                    <v-card-subtitle class="pt-2" style="color:#443e40 !important">
                        {{ formattedDate(menu.itiData1) }}
                    </v-card-subtitle>

                    <v-card-text>
                        <router-link :to="'/BlogDetalhe/' + menu.itiId + '/' + menu.itiNome.replaceAll(' ','-').replaceAll('/','').replaceAll(',','')" style="color:#443e40 !important">
                           <div style="color:#443e40 !important; font-weight:600;font-size:15px;height: 60px;">{{ menu.itiNome }}</div>
                        </router-link>
                    </v-card-text>

                    <v-card-actions>
                        <router-link :to="'/BlogDetalhe/' + menu.itiId + '/' + menu.itiNome.replaceAll(' ','-').replaceAll('/','').replaceAll(',','')" style="color:#443e40 !important">
                            + Detalhes
                        </router-link>
                    </v-card-actions>
                </v-card>             
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </div>
  
</template>

<script>
//import moment from 'moment'
import axios from 'axios';
import { useHead } from '@vueuse/head';
import { Swiper, SwiperSlide } from 'swiper/vue';
import Loader from '@/components/PageLoader.vue'
import Slider from '@/components/PageSlider2.vue'

export default {
  name: 'HomeView',
  components: {
    Swiper,
    SwiperSlide,
    Loader,
    Slider
  },
  data: () => ({
    montaHomeItens:[],
    blocosHome:[],
    montaHomeItensM:[],
    blocosHomeM:[],
    ProdutosDestaque:[],
    blog:[],
    blogLast:[],
    itensHome:[],
    ImagensDuplas:[],
    Atuacao:[],
    cores:[],
  }),
  methods: {
    formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
    formattedDate(value) {
      return this.$moment(value).format('DD/MM/YYYY')
    },
    carregaMetas() {
			useHead({
				title: 'Home - Seleto Industrial Máquinas para Industria Alimentícia'
			})
		},
    AddCarrinho(valueProd){
      console.log(valueProd);
    },
    AjustaUrl(value, nome) {
            let urlFriendlyNomeProduto = nome
                .normalize("NFD") // Normaliza para decompor os caracteres acentuados
                .replace(/[\u0300-\u036f]/g, "") // Remove os caracteres acentuados
                .replace(/[^\w\s-]/g, "") // Remove caracteres especiais
                .replace(/\s+/g, "-") // Substitui espaços em branco por hífens
                .toLowerCase(); // Converte para minúsculas

            return `${value}/${urlFriendlyNomeProduto}`;
        },
  },
  created() {
   this.carregaMetas();

   axios.get('/Process/ProProdutos/GetAllByProdutosDestaques')
            .then(response => {
                this.ProdutosDestaque = response.data;
                this.ProdutosDestaque = this.ProdutosDestaque.sort((a, b) => {
                    return a.proOrdem - b.proOrdem; // Ordena de forma crescente
                });
                //console.log('this.ProdutosDestaque')
                //console.log(this.ProdutosDestaque)

            })
            .catch(error => {
                console.error(error);
            });

            axios.get('/Process/InsInstitucional/institucional/29/blog')
                .then(response => {
                    this.blog = response.data.filter(x => x.itiVisivel).sort((a, b) => {
                    const dataA = new Date(a.itiData1);
                    const dataB = new Date(b.itiData1);

                    return dataA - dataB;
                    })
                    .reverse();
                })
                .catch(error => {
                    console.error(error);
                });

                axios.get('/Process/InsInstitucional/institucional/33/treinamentoseventos')
                .then(response => {
                    this.blogLast = response.data.filter(x => x.itiVisivel && x.itiData1 < this.$moment().format('YYYY-MM-DD')).sort((a, b) => a.itiData1 - b.itiData1).reverse();
                    console.log('response.data')
                    console.log(response.data)

                })
                .catch(error => {
                    console.error(error);
                });
       
                axios.get('/Process/InsInstitucional/institucional/38/itenshome')
                .then(response => {
                    this.itensHome = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
                })
                .catch(error => {
                    console.error(error);
                });


                axios.get('/Process/InsInstitucional/institucional/41/coresfundo')
                .then(response => {
                    this.cores = response.data;
                })
                .catch(error => {
                    console.error(error);
                });

                

                axios.get('/Process/InsInstitucional/institucional/39/imagensduplas')
                .then(response => {
                    this.ImagensDuplas = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
                })
                .catch(error => {
                    console.error(error);
                });

                axios.get('/Process/InsInstitucional/institucional/40/atuacao')
                .then(response => {
                    this.Atuacao = response.data;
                })
                .catch(error => {
                    console.error(error);
                });

                

  },
  computed: {
    columns() {
      return 2;
    }
  },
}
</script>

<style>

/** */
.image-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.image {
  width: 100%;
  height: auto;
  display: block;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0); /* Transparente por padrão */
  transition: background-color 0.3s ease; /* Transição suave */
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay:hover {
  background-color: rgba(0, 0, 0, 0.5); /* Adicione aqui a cor e opacidade desejadas */
}

.text {
  text-align: center;
  color: white;
  padding: 20px;
}

/** */


   .das {
            display: block !important;
        }

    .slider-text h2 p{
      font-size: 60px;
      color:#081624;
      padding:10px;
      display: inline-block;
      background: #99CC33;
      line-height: 1;
    }

    .swiper, swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden; 
    list-style: none;
    padding: 0;
    z-index: 1;
    display: block;
}

.swiper-pagination-bullet-active {
    opacity: var(--swiper-pagination-bullet-opacity, 1);
    background: #cccccc !important;
}

.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-horizontal > .swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: var(--swiper-pagination-bottom, -5px) !important;
    top: var(--swiper-pagination-top, auto);
    left: 0;
    width: 100%;
}

.swiper-button-prev, .swiper-button-next{
    color:#cccccc !important;
}
@media (max-width:767px) {

    .product-price {
    display: flex;
    align-items: center;
    flex-flow: wrap;
    font-weight: 400;
    font-size: 20px;
    line-height: 1.25;
    color: #0a98f8;
    margin-bottom: 13px;
}
}

</style>
